import React from 'react';
import PropTypes from 'prop-types';
import { EMPTY_STRING } from '../../../constants/constants';
import './text-input.style.scss';

/**
 * Class representing text input.
 * @extends React.Component
 * */
class TextInput extends React.Component {

  state = {
    value: EMPTY_STRING,
  };

  /**
   * Change event trigger.
   * @param {object} event - The event value.
   * */
  onChange = (event) => {
    const { onValueChange } = this.props;
    const { value } = event.target;

    this.setState({ value });
    onValueChange(value);
  };

  /**
   * Enter Key press event trigger.
   * @param {object} event - The event value.
   * */
  onKeyPressed = (event) => {
    if (event && event.key === 'Enter') {
      const { onEnterKeyValueChange } = this.props;
      const { value } = event.target;

      this.setState({ value });
      onEnterKeyValueChange(value);
    }
  }

  render() {
    const { inputClass, placeholder, type } = this.props;
    const { value } = this.state;

    return (
      <div className="input-wrapper">
        <input
          required
          type={type}
          value={value}
          onChange={this.onChange}
          className={`form-control ${inputClass}`}
          placeholder={placeholder}
          onKeyPress={this.onKeyPressed}
        />
      </div>
    );
  }

}

export default TextInput;

TextInput.propTypes = {
  inputClass: PropTypes.string,
  onValueChange: PropTypes.func.isRequired,
  onEnterKeyValueChange: PropTypes.func,
  placeholder: PropTypes.string,
  type: PropTypes.string.isRequired,
};

TextInput.defaultProps = {
  inputClass: EMPTY_STRING,
  onEnterKeyValueChange: null,
  placeholder: EMPTY_STRING,
};



// WEBPACK FOOTER //
// ./src/common/components/text-input/text-input.component.js